export default "__VITE_ASSET__DVWY2Peo__"